module.exports = __webpack_public_path__ + "69aed1086594900090e2b2f4552a9c5e.svg";